import React, { useState, useEffect } from 'react';

const ClientOnlyFsLightbox = ({ toggler, sources, slide }) => {
  const [FsLightboxComponent, setFsLightboxComponent] = useState(null);

  useEffect(() => {
    // Динамически импортируем только на клиенте
    if (typeof window !== 'undefined') {
      import('fslightbox-react').then((module) => {
        setFsLightboxComponent(() => module.default);
      });
    }
  }, []);

  if (!FsLightboxComponent) return null;

  return <FsLightboxComponent 
    toggler={toggler} 
    sources={sources} 
    slide={slide} 
  />;
};

export default ClientOnlyFsLightbox;